import Table from "@mui/material/Table";
import { wfComments } from "../../types/types";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Typography from "@mui/material/Typography";
import { actionTypes, currPathValue, pdfMode, saveButtonMode, uiItemNames } from "../../types/enums";
// import { Label } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { fields, mapFieldToText } from "../../lang/constants";
import { setStateItem } from "../../actions/actionsBase";
import store from "../../configureStore";
import { toLocaleUTCDateString } from "../../actions/folderViewActions";

interface CommentListProps {
    comments: wfComments[],
    parent: currPathValue,
    LoadPdf: (fileRno:number, clientSide:boolean, mode: pdfMode, saveBtnMode: saveButtonMode) => void;
    //openPopover: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const CommentList = (props:CommentListProps) => {

    return (
            <Table size="small" padding="none">
                <TableHead>
                    <TableRow>
                        <TableCell><Typography><b>{mapFieldToText(fields.COMMENT_LIST_COMMENT)}</b></Typography></TableCell>
                        <TableCell><Typography><b>{mapFieldToText(fields.COMMENT_LIST_BY)}</b></Typography></TableCell>
                        <TableCell><Typography><b>{mapFieldToText(fields.COMMENT_LIST_CREATED)}</b></Typography></TableCell>
                        <TableCell><Typography><b>{mapFieldToText(fields.COMMENT_LIST_ACTIVITY)}</b></Typography></TableCell>
                        <TableCell><Typography><b>{mapFieldToText(fields.COMMENT_LIST_DOC_ID)}</b></Typography></TableCell>
                        <TableCell><Typography><b>{mapFieldToText(fields.COMMENT_LIST_REV_ID)}</b></Typography></TableCell>
                    </TableRow>
                </TableHead>
                {props.comments.sort((a, b) => (new Date(b.created)).getTime() - (new Date(a.created)).getTime()).map((comm:wfComments) => {
                    return  <>
                                <TableRow key={comm.commentRno}>
                                    <TableCell><Typography>{comm.comment}</Typography></TableCell>
                                    <TableCell><Typography>{comm.commentedByUserName}</Typography></TableCell>
                                    {/* <TableCell><Typography>{comm.created.split('.')[0].replace('T', ' ')}</Typography></TableCell> */}
                                    <TableCell><Typography>{toLocaleUTCDateString(comm.created,true)}</Typography></TableCell>
                                    <TableCell><Typography>{comm.activityName}</Typography></TableCell>
                                    <TableCell><Typography>{comm.docId === null ? "" : comm.docId}</Typography></TableCell>
                                    <TableCell><Typography>{comm.revisionId === null ? "" : comm.revisionId}</Typography></TableCell>
                                </TableRow>
                                {comm.Attachments !== undefined && 
                                   <>
                                        {comm.Attachments.length>0 &&
                                        <TableRow>
                                            <TableCell><Typography>Attachments:</Typography></TableCell>
                                            <TableCell colSpan={5}>{comm.Attachments.map(x=>{
                                                return <>
                                                        <Button onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                                                        //props.openPopover(event);
                                                                                        props.LoadPdf(x.FileRno,true,x.Extension.toUpperCase() === "PDF" ? pdfMode.edit : pdfMode.view, saveButtonMode.save)
                                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [...store.getState().uiItems.previousPath].concat([props.parent])));
                                                                            }
                                                        }>
                                                            <Typography>{x.OriginalFileName}</Typography>
                                                        </Button>
                                                        {/* {   x.Extension.toUpperCase() === "PDF" &&
                                                            <Button onClick={(event: React.MouseEvent<HTMLButtonElement>)=>{
                                                                                        //props.openPopover(event);
                                                                                        props.LoadPdf(x.FileRno,true,pdfMode.edit,saveButtonMode.save)
                                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.currentPath, currPathValue.PdfTron));
                                                                                        store.dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.previousPath, [props.parent]));
                                                                    }
                                                                }>
                                                                <Typography>edit</Typography>
                                                            </Button>
                                                        } */}
                                                    </>
                                            })}</TableCell>
                                        </TableRow>}
                                    </>
                                }
                            </>
                })}
            </Table>
    )
}

